<pp-side-panel-menu-button
  [ppText]="'timeline' | ppTranslate"
  [ppDataTarget]="'Timeline icon'"
  [ppDataTest]="'timelineMenuItem'"
  [ppIconSrc]="EIconPath.SIDE_PANEL_TIMELINE"
  [ppActive]="ppRouterPath === '/site/timeline'"
  [ppDisabled]="ppDisabled"
  (ppAction)="goToTimeline()"
></pp-side-panel-menu-button>
